export const getMediaQueries = state =>
  state.session.responsive;



// WEBPACK FOOTER //
// ./src/client/js/store/selectors/responsive.js